import { render, staticRenderFns } from "./GeneralPopup.vue?vue&type=template&id=7cb37ccd"
import script from "./GeneralPopup.vue?vue&type=script&lang=js"
export * from "./GeneralPopup.vue?vue&type=script&lang=js"
import style0 from "./GeneralPopup.vue?vue&type=style&index=0&id=7cb37ccd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports